//TODO - We need to pass in all the current values also .....

export const CreateApprovalApiRequest = (existingValues, newValues, id) => {
  if (!newValues) return null;

  const request = { ...existingValues };
  request.homesaleId = id;
  request.appraisalValue = newValues.appraisalValue ? parseFloat(newValues.appraisalValue) : null;
  request.offerAmount = newValues.offerAmount ? parseFloat(newValues.offerAmount) : null;
  request.offerDate = newValues.offerDate === '' ? null : newValues.offerDate;
  request.daysOfferValid = newValues.daysOfferValid === '' ? null : newValues.daysOfferValid;
  request.offerSentDate = newValues.offerSentDate === '' ? null : newValues.offerSentDate;
  request.offerSentTo = newValues.offerSentTo;
  request.offerSentVia = newValues.offerSentVia;
  request.clientApprovedDate = newValues.clientApprovedDate === '' ? null : newValues.clientApprovedDate;
  request.clientApprovedBy = newValues.clientApprovedBy ? parseInt(newValues.clientApprovedBy) : null;
  request.approvalConcessions = newValues.approvalConcessions ? parseFloat(newValues.approvalConcessions) : null;
  request.initialBillDate = newValues.initialBillDate === '' ? null : newValues.initialBillDate;
  request.contingencies = newValues.contingencies;
  request.appSubjectTo = newValues.appSubjectTo;
  request.personalPropertyIncluded = newValues.personalPropertyIncluded;
  request.personalPropertyExcluded = newValues.personalPropertyExcluded;
  request.modifiedOn = new Date().toISOString();

  return request;
};

export const CreateAcceptanceApiRequest = (existingValues, newValues, id) => {
  if (!newValues) return null;

  const toFloatOrNull = value => {
    if (value === null || value === undefined || value === '') return null;
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : null;
  };

  const request = { ...existingValues };
  request.homesaleId = id;
  // Saved to the homesale record by the buyout update.
  request.saleTypeId = newValues.saleTypeId;
  request.offerAcceptAmount = toFloatOrNull(newValues.offerAcceptAmount);
  request.offerAcceptDate = newValues.offerAcceptDate === '' ? null : newValues.offerAcceptDate;
  request.verbalOfferAcceptDate = newValues.verbalOfferAcceptDate === '' ? null : newValues.verbalOfferAcceptDate;
  request.directedEquity = toFloatOrNull(newValues.directedEquity);
  request.acceptanceConcessions = toFloatOrNull(newValues.acceptanceConcessions);
  request.buyoutHomeWarranty = toFloatOrNull(newValues.buyoutHomeWarranty);
  request.buyoutRepairs = newValues.buyoutRepairs;
  request.buyoutAgreementReceived = newValues.buyoutAgreementReceived === '' ? null : newValues.buyoutAgreementReceived;
  request.repairsAmount = toFloatOrNull(newValues.repairsAmount);
  request.vacateDate = newValues.vacateDate === '' ? null : newValues.vacateDate;
  request.prorateDate = newValues.prorateDate === '' ? null : newValues.prorateDate;
  request.posessionDate = newValues.posessionDate === '' ? null : newValues.posessionDate;
  request.insureDate = newValues.insureDate === '' ? null : newValues.insureDate;
  request.endInsureDate = newValues.endInsureDate === '' ? null : newValues.endInsureDate;
  request.offerExtensionGranted = newValues.offerExtensionGranted === '' ? null : newValues.offerExtensionGranted;
  request.offerExtensionExpires = newValues.offerExtensionExpires === '' ? null : newValues.offerExtensionExpires;
  request.reAppraisalOrderedDate = newValues.reAppraisalOrderedDate === '' ? null : newValues.reAppraisalOrderedDate;
  request.offerRejectedDate = newValues.offerRejectedDate === '' ? null : newValues.offerRejectedDate;
  request.offerFollowupDate = newValues.offerFollowupDate === '' ? null : newValues.offerFollowupDate;
  request.fundDate = newValues.fundDate === '' ? null : newValues.fundDate;
  request.avsAcceptAmount = toFloatOrNull(newValues.avsAcceptAmount);
  request.hireStatus = newValues.hireStatus;
  request.offerDecision = newValues.offerDecision;
  request.offerExpiresDate = newValues.offerExpiresDate === '' ? null : newValues.offerExpiresDate;
  request.actualBuyoutCloseDate = newValues.actualBuyoutCloseDate === '' ? null : newValues.actualBuyoutCloseDate;
  request.modifiedOn = new Date().toISOString();


  return request;
};

export const CreatePersonalPropertyApiRequest = (existingValues, newValues, id) => {
  if (!newValues) return null;

  const request = { ...existingValues };
  request.homesaleId = id;
  request.personalPropertyIncluded = newValues.personalPropertyIncluded;
  request.personalPropertyExcluded = newValues.personalPropertyExcluded;
  request.modifiedOn = new Date();

  return request;
};

// Local Title card edits (PUT {fileId}/homesale/titleDocument). Like the other buyout cards it sends the loaded buyout
// with the card's values over it; the server only reads the title fields and keeps the rest of Morreale's title document.
export const CreateTitleDocumentApiRequest = (existingValues, newValues) => {
  if (!newValues) return null;

  const dateOrNull = value => (value === '' || value === undefined ? null : value);

  const request = { ...existingValues };
  request.titleCompanyName = newValues.titleCompanyName ?? '';
  request.titleAddressLineOne = newValues.titleAddressLineOne ?? '';
  request.titleAddressLineTwo = newValues.titleAddressLineTwo ?? '';
  request.titleAddressCity = newValues.titleAddressCity ?? '';
  request.titleAddressProvinceId = newValues.titleAddressProvinceId || null;
  request.titleAddressZipcode = newValues.titleAddressZipcode ?? '';
  request.titleOrderedDate = dateOrNull(newValues.titleOrderedDate);
  request.titleDueDate = dateOrNull(newValues.titleDueDate);
  request.titleReceivedDate = dateOrNull(newValues.titleReceivedDate);
  request.titleOrderNumber = newValues.titleOrderNumber ?? '';
  request.titleDocsSentTo = newValues.titleDocsSentTo ?? '';
  request.titleDocsSentForSignature = dateOrNull(newValues.titleDocsSentForSignature);
  request.titleDocsReceivedBackDate = dateOrNull(newValues.titleDocsReceivedBackDate);
  request.titleDeadline = dateOrNull(newValues.titleDeadline);
  request.inspectionObjectionDeadline = dateOrNull(newValues.inspectionObjectionDeadline);
  request.resolution = dateOrNull(newValues.resolution);

  return request;
};

export const CreateSendOfferPackageRequest = (existingValues, id) => {
  return {
    ...existingValues,
    offerPackageSent: true,
    authorizationId: id,
  };
};

export const CreateRequestInsurancePlacementRequest = (existingValues, id) => {
  return {
    ...existingValues,
    insurancePlacementSent: true,
    authorizationId: id,
  };
};

export const CreateResetButtonStatusApiRequest = (existingValues, id) => {
  return {
    ...existingValues,
    offerPackageSent: false,
    insurancePlacementSent: false,
    authorizationId: id,
  };
};
